import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import { getRootUrl } from '@share-a-cart/shared-utils';
import { useMemo } from 'react';
import { UAParser } from 'ua-parser-js';

import SafariIOSMenuIcon from 'src/images/icons/safari-ios-menu-icon.png';
import SafariIOSExtensionsIcon from 'src/images/icons/safari-ios-extensions-icon.png';
import FullCartIcon from 'src/images/icons/full-cart-icon.png';

export const SafariIosHelper = () => {
  const { browser: { name: browserName } } = useMemo(() => UAParser(navigator.userAgent), []);

  if (browserName !== 'Mobile Safari') {
    window.location.href = getRootUrl();
    return null;
  }

  return (
    <div className="custom-safari-ios-container">
      <h1>How to enable Share-A-Cart for Safari</h1>
      <ul>
        <li>
          <div className="custom-safari-ios-step-icon">
            <img src={SafariIOSMenuIcon} alt="Safari iOS Menu Icon" />
          </div>
          <div className="custom-safari-ios-step-text">
            Select <img src={SafariIOSMenuIcon} alt="Safari iOS Menu Icon" /> in the address bar
          </div>
        </li>
        <li>
          <div className="custom-safari-ios-step-icon">
            <img src={SafariIOSExtensionsIcon} alt="Safari iOS Extensions Icon" />
          </div>
          <div className="custom-safari-ios-step-text">
            Choose <b>Manage Extensions</b>.
          </div>
        </li>
        <li>
          <div className="custom-safari-ios-step-icon">
            <ToggleOnOutlinedIcon className="img-icon" />
          </div>
          <div className="custom-safari-ios-step-text">
            Turn on <b>Share-A-Cart</b>, then tap <b>Done</b>.
          </div>
        </li>
        <li>
          <div className="custom-safari-ios-step-icon">
            <img src={FullCartIcon} alt="SAC Cart Icon" />
          </div>
          <div className="custom-safari-ios-step-text">
            Select <img src={SafariIOSMenuIcon} alt="Safari iOS Menu Icon" /> again, and choose <b>Share-A-Cart</b>.
          </div>
        </li>
        <li>
          <div className="custom-safari-ios-step-icon">
            <CheckCircleOutlineRoundedIcon className="img-icon" />
          </div>
          <div className="custom-safari-ios-step-text">
            Select <b>Always Allow</b>, and then <b>Always Allow on Every Website</b>.
          </div>
        </li>
      </ul>

      <p className="text-center pt-20 pb-2">
        When you're ready, return to the app
      </p>
      <div className="flex justify-center">
        <button
          className="button-primary w-full h-12"
          onClick={ () => { window.location.href = 'share-a-cart://'; }}
        >
          Open Share-A-Cart
        </button>
      </div>
    </div>
  );
};